import {
  ProductProjectEventStatDTO,
  ProductProjectSalesDTO,
  SalesDTOObject,
  TotalPeriodStatDTOObject
} from 'models'

export enum OverviewStatTabs {
  BY_EXPENSES = 'BY EXPENSES',
  BY_INTERACTION = 'BY INTERACTION',
  BY_REVENUE = 'BY REVENUE'
}

export type ProductProjectStat = Partial<ProductProjectEventStatDTO> &
  Partial<ProductProjectSalesDTO>

export type TotalPeriodData = {
  sales: SalesDTOObject,
  periodStats: TotalPeriodStatDTOObject
}

export type TotalPeriodDataMap = Map<number, TotalPeriodData>
